/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const ParseAPIExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'parseError',
        /* #__PURE__ */ codec.record(codecString, codec.unknown),
        'parse_error',
    ],
]), BaseError);
export class ParseAPIException extends BaseError {
    static decode(input) {
        return ParseAPIExceptionParser.decode(input).map(res => new ParseAPIException(res));
    }
    static unsafeDecode(input) {
        return ParseAPIException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ParseAPIExceptionParser.encode(data);
    }
    static schema() {
        return ParseAPIExceptionParser.schema();
    }
}
